import { NoRowsOverlayMessage } from './NoRowsOverlay.styles';

const NoRowsOverlay = ({ message = 'No records available' }) => (
  <NoRowsOverlayMessage data-testid='NoRowsOverlay'>{message}</NoRowsOverlayMessage>
);

export default NoRowsOverlay;
